// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YPynU","toggle":"styles_toggle__mDVif","preview":"styles_preview__2Di0i"};